import {
  isEmpty,
  PayMedium
} from "../constants/constant";

export const addClass = (element, classList) => {
    let count = 0;

    if (classList && classList.length) {
        for (count; count < classList.length; count++) {
            if (element.className.indexOf(classList[count]) === -1) {
                element.className = element.className.trim();
                element.className += " " + classList[count];
            }
        }
    }
};

export const removeClass = (element, classList) => {
    let count = 0;

    if (classList && classList.length) {
        for (count; count < classList.length; count++) {
            element.className = element.className.replace(
                new RegExp("(\\s|^)" + classList[count] + "(\\s|$)"),
                " "
            );
        }
    }
};


export const hasClass = (element, classname) => {
    if ((" " + element.className + " ").replace(/[\n\t]/g, " ").indexOf(classname) > -1) return true;
    return null;
}

//Input Field Validations
export const ZIPCODE_REGEX = /^\d{5}(-\d{4})*$/;

export const REMOVE_ALL_SPECIAL_CHARACTERS = /[^a-zA-Z0-9]/g;

export const IS_ONLY_ALPHABET_REGEX = /^[a-zA-Z]+$/;

export const IS_ONLY_NUMBER_REGEX = /^\d+$/;

export const STREET_ADDRESS_REGEX = /[!$%^&*@()_+|~=`\\{}[\]:";<>?']/;

export const VUNERABLE_CHAR_REGEX = /[<>()]+/;

export const NAME_REGEX = /^([a-zA-Z][\s]|[a-zA-Z])+$/;

export const STREET_ADDREE_TWO_ERROR_REGEX = /[^a-zA-Z0-9-,#./]/;           //doubt

export const emailCheck = value => {
    let isValid = true;
    let emailRegex = /^([a-zA-Z0-9])([a-zA-Z0-9]|[_-])*(([a-zA-Z0-9]|[_-])+[.]([a-zA-Z0-9]|[_-])+)*([.]([a-zA-Z0-9]|[_-])+)*[@]([a-zA-Z0-9]|[_-])+[.][a-zA-Z]{2,}$/;
    let isEmailValidated = emailRegex.test(value);
    if (!isEmailValidated) {
        isValid = false;
    }
    return isValid;
}

export const getPayMedium = (cashAllowed, onlineAllowed) => {
    let mPayMedium = PayMedium.NOPAY;
    if (cashAllowed && onlineAllowed)
        mPayMedium = PayMedium.BOTH;
    else if (cashAllowed && !onlineAllowed)
        mPayMedium = PayMedium.CASH;
    else if (!cashAllowed && onlineAllowed)
        mPayMedium = PayMedium.ONLINE;
    return mPayMedium;
}

export const getConfigValueByKey = (restoBillConfig = {}, configKey) => {
    const { configs } = restoBillConfig;
    return configs && configs.hasOwnProperty(configKey) ? configs[configKey] : false;
}

export function jumbleString(input) {
    const mid = input.length / 2;
    let parts = [input.substring(0, mid), input.substring(mid)];
    return (
        parts[0].split("").reverse().join("") +
        parts[1].split("").reverse().join("")
    );
}
export function encode(input) {
    input = this.jumbleString(input);
    let word = "";
    for (let index = 0; index < input.length; index++) {
        let c = input.charCodeAt(index) + 3;
        word = word + String.fromCharCode(c);
    }
    return word;
}

export function decode(input) {
    if (isEmpty(input)) return input;
    let org = "";
    for (let index = 0; index < input.length; index++) {
        const c = input.charCodeAt(index) - 3;
        org = org + String.fromCharCode(c);
    }
    org = this.jumbleString(org);
    return org;
}